import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import {
  getRolePermissions
} from 'src/services/authService';
import ResourcePoolView from './ResourcePoolView';
import { useParams } from 'react-router';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';

function ResourcePool() {
  const navigate = useNavigate();
  const params = useParams();

  const [permissions, setPermissions] = useState([]);
  const [tabValue, setTabValue] = useState<any>(null);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Resource Pool');
      setPermissions(arr[0].permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  useEffect(() => {
    if(permissions.length > 0){
      const hasViewResources = permissions.some((perm) => perm.name === 'View Resources' && perm.value === true);
      const hasViewDashboard = permissions.some((perm) => perm.name === 'View Dashboard' && perm.value === true);
      const hasViewProjects = permissions.some((perm) => perm.name === 'View Projects' && perm.value === true);

      if(hasViewResources && !hasViewDashboard){
        setTabValue('resource');
      }
      if(hasViewProjects && !hasViewDashboard){
        setTabValue('project');
      }
    }
  }, [permissions])

  return (
    <>
      <Helmet>
        <title>Resource Management</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            {permissions.length > 0 && 
            <ResourcePoolView 
              tab={tabValue ? tabValue : params.type}
              permissions={permissions}/>
            }
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default ResourcePool;
